export enum ETutorialAudienceType {
  Store = "Store",

  Courier = "Courier",

  Both = "Both",
}
